<template>
  <v-card>
    <v-card-title>
      <span class="headline">{{ $t('userSettingsDesktop.description') }}</span>
    </v-card-title>
    <v-card-text>
      <v-row v-if="clientConfig.demoMode">
        <v-col>
          <h2>Theme</h2>

          <v-switch
            v-model="uiStore.isDarkMode"
            hint="This toggles the color theme between a light and dark mode"
            inset
            label="Dark Theme"
            persistent-hint
          />
        </v-col>
      </v-row>

      <v-row v-if="clientConfig.demoMode">
        <v-col>
          <h2>Testing</h2>

          <v-switch
            v-model="forceMarketTimeframesCheckingEvenWhenDisabled"
            :disabled="clientConfig.marketTimeframesEnabled"
            hint="Enforce the market timeframes on actions"
            inset
            label="Enforce Market Timeframes"
            persistent-hint
          />

          <v-switch
            v-model="forceMarketTimeframesClosed"
            hint="Force all market timeframes being closed"
            inset
            label="Force Market Timeframes closed"
            persistent-hint
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { mapMutations, mapState } from 'vuex';
import { ClientConfig, UXConfig } from '@/utils/helpers/rest';
import { extend } from 'lodash';
import { UIStore, useUIStore } from '@/store/ui-store';

@Component({
  methods: {
    ...mapMutations(['updateUXConfig']),
  },
  computed: {
    ...mapState(['uxConfig', 'clientConfig']),
  },
  setup() {
    return {
      uiStore: useUIStore(),
    };
  },
})
export default class DesktopConfiguration extends Vue {
  protected uiStore!: UIStore;

  // store state refs
  private uxConfig!: UXConfig;
  private clientConfig!: ClientConfig;

  // store mutations
  private updateUXConfig!: (config: UXConfig) => void;

  protected get forceMarketTimeframesCheckingEvenWhenDisabled(): boolean {
    return (
      this.uxConfig.forceMarketTimeframesCheckingEvenWhenDisabled ||
      this.clientConfig.marketTimeframesEnabled
    );
  }

  protected set forceMarketTimeframesCheckingEvenWhenDisabled(force: boolean) {
    const config: UXConfig = extend({}, this.uxConfig, {
      forceMarketTimeframesCheckingEvenWhenDisabled: force,
    });
    this.updateUXConfig(config);
  }

  protected get forceMarketTimeframesClosed(): boolean {
    return this.uxConfig.forceMarketTimeframesClosed;
  }

  protected set forceMarketTimeframesClosed(forceMarketTimeframesClosed: boolean) {
    const config: UXConfig = extend({}, this.uxConfig, { forceMarketTimeframesClosed });
    this.updateUXConfig(config);
  }
}
</script>

<style lang="scss" scoped></style>
